import { 
  Heart, Pause, Eye, EyeOff, AlertTriangle, Target, Snowflake, Bug,
  Moon, Activity, Sparkles, Minus, ShieldAlert, Brain, Sword, Wind,
  Zap, RotateCcw, Users, CircleDot
} from 'lucide-react';

// D&D 5e Conditions with icons and descriptions
export const DND_CONDITIONS = [
  { id: 'blinded', label: { fr: 'Aveuglé', en: 'Blinded' }, icon: EyeOff, color: '#6B7280', description: { fr: 'Ne peut pas voir', en: 'Cannot see' } },
  { id: 'charmed', label: { fr: 'Charmé', en: 'Charmed' }, icon: Heart, color: '#EC4899', description: { fr: 'Ne peut attaquer le charmeur', en: 'Cannot attack charmer' } },
  { id: 'deafened', label: { fr: 'Assourdi', en: 'Deafened' }, icon: EyeOff, color: '#6B7280', description: { fr: 'Ne peut pas entendre', en: 'Cannot hear' } },
  { id: 'frightened', label: { fr: 'Effrayé', en: 'Frightened' }, icon: AlertTriangle, color: '#F59E0B', description: { fr: 'Désavantage tant que source visible', en: 'Disadvantage while source visible' } },
  { id: 'grappled', label: { fr: 'Agrippé', en: 'Grappled' }, icon: Target, color: '#EF4444', description: { fr: 'Vitesse 0', en: 'Speed 0' } },
  { id: 'incapacitated', label: { fr: 'Incapable', en: 'Incapacitated' }, icon: Pause, color: '#7C3AED', description: { fr: 'Pas d\'action ni réaction', en: 'No actions or reactions' } },
  { id: 'invisible', label: { fr: 'Invisible', en: 'Invisible' }, icon: Eye, color: '#06B6D4', description: { fr: 'Impossible à voir', en: 'Cannot be seen' } },
  { id: 'paralyzed', label: { fr: 'Paralysé', en: 'Paralyzed' }, icon: Snowflake, color: '#3B82F6', description: { fr: 'Incapable, échoue FOR/DEX', en: 'Incapacitated, fail STR/DEX' } },
  { id: 'petrified', label: { fr: 'Pétrifié', en: 'Petrified' }, icon: CircleDot, color: '#78716C', description: { fr: 'Transformé en pierre', en: 'Turned to stone' } },
  { id: 'poisoned', label: { fr: 'Empoisonné', en: 'Poisoned' }, icon: Bug, color: '#22C55E', description: { fr: 'Désavantage attaques/carac.', en: 'Disadvantage attacks/abilities' } },
  { id: 'prone', label: { fr: 'À terre', en: 'Prone' }, icon: Minus, color: '#A16207', description: { fr: 'Désavantage, doit ramper', en: 'Disadvantage, must crawl' } },
  { id: 'restrained', label: { fr: 'Entravé', en: 'Restrained' }, icon: ShieldAlert, color: '#DC2626', description: { fr: 'Vitesse 0, désavantage DEX', en: 'Speed 0, DEX disadvantage' } },
  { id: 'stunned', label: { fr: 'Étourdi', en: 'Stunned' }, icon: Sparkles, color: '#FBBF24', description: { fr: 'Incapable, échoue FOR/DEX', en: 'Incapacitated, fail STR/DEX' } },
  { id: 'unconscious', label: { fr: 'Inconscient', en: 'Unconscious' }, icon: Moon, color: '#1E293B', description: { fr: 'À terre, incapable', en: 'Prone, incapacitated' } },
  { id: 'exhaustion', label: { fr: 'Épuisement', en: 'Exhaustion' }, icon: Activity, color: '#9333EA', description: { fr: 'Niveaux 1-6', en: 'Levels 1-6' } },
  { id: 'concentration', label: { fr: 'Concentration', en: 'Concentration' }, icon: Brain, color: '#0EA5E9', description: { fr: 'Maintient un sort', en: 'Maintaining a spell' } }
];

export const DIFFICULTY_COLORS = {
  trivial: 'bg-gray-500', 
  easy: 'bg-green-500', 
  medium: 'bg-yellow-500',
  hard: 'bg-orange-500', 
  deadly: 'bg-red-500'
};

export const DIFFICULTY_LABELS = {
  fr: { trivial: 'Trivial', easy: 'Facile', medium: 'Moyen', hard: 'Difficile', deadly: 'Mortel' },
  en: { trivial: 'Trivial', easy: 'Easy', medium: 'Medium', hard: 'Hard', deadly: 'Deadly' }
};

export const STATUS_LABELS = {
  fr: { preparing: 'Préparation', active: 'En cours', paused: 'En pause', completed: 'Terminé' },
  en: { preparing: 'Preparing', active: 'Active', paused: 'Paused', completed: 'Completed' }
};

export const QUICK_ACTIONS = [
  { id: 'attack', label: { fr: 'Attaque', en: 'Attack' }, icon: Sword },
  { id: 'dodge', label: { fr: 'Esquive', en: 'Dodge' }, icon: Wind },
  { id: 'dash', label: { fr: 'Course', en: 'Dash' }, icon: Zap },
  { id: 'disengage', label: { fr: 'Désengagement', en: 'Disengage' }, icon: RotateCcw },
  { id: 'help', label: { fr: 'Aide', en: 'Help' }, icon: Users },
  { id: 'hide', label: { fr: 'Se cacher', en: 'Hide' }, icon: EyeOff },
  { id: 'ready', label: { fr: 'Préparer', en: 'Ready' }, icon: Target }
];

export const HP_STATUS_COLORS = {
  healthy: { bg: 'bg-green-500', text: 'text-green-500', label: { fr: 'En forme', en: 'Healthy' } },
  injured: { bg: 'bg-yellow-500', text: 'text-yellow-500', label: { fr: 'Blessé', en: 'Injured' } },
  bloodied: { bg: 'bg-orange-500', text: 'text-orange-500', label: { fr: 'Ensanglanté', en: 'Bloodied' } },
  critical: { bg: 'bg-red-500', text: 'text-red-500', label: { fr: 'Critique', en: 'Critical' } },
  down: { bg: 'bg-gray-500', text: 'text-gray-500', label: { fr: 'À terre', en: 'Down' } }
};
